import type { RouteRecordRaw } from 'vue-router'

/**
 * 酒店选择路由（PLAN-H5-01 切片 4，本套维护）
 *
 * - 由 getDynamicPackageRoutes 统一导出（H5-02 在 router.ts 展开）；
 * - detail 只带 resourceId 及行程 query，不把资源对象入 URL；
 * - meta.title 为占位，列表页标题按稿为「{目的地名称}酒店」，待 UI 切片按定稿核对后回填。
 */
export const hotelRoutes: RouteRecordRaw[] = [
  {
    path: '/dynamicPackage/hotelSelect',
    name: 'DynamicPackageHotelSelect',
    component: () => import('../views/hotelSelect/index.vue'),
    meta: { title: '酒店' }
  },
  {
    path: '/dynamicPackage/hotelDetail',
    name: 'DynamicPackageHotelDetail',
    component: () => import('../views/hotelSelect/detail.vue'),
    meta: { title: '酒店详情' }
  }
]
